import { render, staticRenderFns } from "./logisticstracking.vue?vue&type=template&id=2fc0c82e&scoped=true"
import script from "./logisticstracking.vue?vue&type=script&lang=ts"
export * from "./logisticstracking.vue?vue&type=script&lang=ts"
import style0 from "./logisticstracking.vue?vue&type=style&index=0&id=2fc0c82e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0c82e",
  null
  
)

export default component.exports